import Vue from "vue";
import DomPortal from "vue-dom-portal";

import App from "./App.vue";
import "./assets/tailwind.css";

const body = document.querySelector("body");
const app = document.createElement("div");
app.id = "app-reviews";
body.appendChild(app);

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
  faCircleCheck,
  faCircleXmark,
  faShareNodes,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
// import { faThumbsUp } from '@fortawesome/free-regular-svg-icons'

/* add icons to the library */
library.add([faCircleCheck, faThumbsUp, faShareNodes, faCircleXmark]);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(DomPortal);

new Vue({
  render: h => h(App),
}).$mount("#app-reviews");
